import { render, staticRenderFns } from "./TeamSelection.vue?vue&type=template&id=1e581db1&scoped=true&"
import script from "./TeamSelection.vue?vue&type=script&lang=js&"
export * from "./TeamSelection.vue?vue&type=script&lang=js&"
import style0 from "./TeamSelection.vue?vue&type=style&index=0&id=1e581db1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e581db1",
  null
  
)

export default component.exports